import { FallbackImage, FallbackImageWithoutRegExp } from './model/fallback-image';
import { transformToCdnUrl } from 'utils/google-storage-util';

export const DEFAULT_FALLBACK_IMAGE: FallbackImageWithoutRegExp = {
    fullWidth: false,
    src: transformToCdnUrl('embedded-assets/skeleton/main-skeleton.webp'),
};

export const FALLBACK_IMAGES: FallbackImage[] = [
    {
        regExp: /^\/(orders)$/,
        fullWidth: true,
        src: transformToCdnUrl('embedded-assets/skeleton/main-skeleton.webp'),
    },
];
